<template>
    <div>
        <b-list-group-item
            class="lista-menu"
            v-if="$temAcessoView('REL-PAGMEN-00')"
            @click.stop="abrirPainel()"
            ><span>PAGAMENTOS MENSAIS</span>
        </b-list-group-item>
    </div>
</template>

<script>
export default {
    methods: {
        abrirPainel() {
            this.$router.push({name: 'Painel_PagamentosMensais'})
        }
    }
}
</script>
